import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import * as artifactActions from '~/artifact/actions';
import ArtifactViewSelect from '~/artifact/containers/ArtifactViewSelect';
import { vulnerabilityRangeTypesMap } from '~/constants/ModelConstants';
import Helpers from '~/utils/Helpers';
type ArtifactViewMainContentFixInfoRangeOverviewProps = {
  actions: object;
  artifactState: object;
  artifact: object;
  rangeType?: string;
};
class ArtifactViewMainContentFixInfoRangeOverview extends React.Component<
  ArtifactViewMainContentFixInfoRangeOverviewProps,
  {}
> {
  constructor(props, context) {
    super(props, context);
  }
  componentDidMount() {
    let store = this.props.artifactState,
      artifact = this.props.artifact,
      rangeType = this.props.rangeType || vulnerabilityRangeTypesMap.VERSIONS,
      currentComponentId = store.componentId,
      artifactComponents = artifact.artifactComponents,
      currentArtifactComponent =
        _.find(artifactComponents, artifactComponent => {
          return artifactComponent.componentId === currentComponentId;
        }) || {},
      versionRanges = currentArtifactComponent.versionRanges || [];
    if (rangeType === vulnerabilityRangeTypesMap.COMMIT_HASHES) {
      const versionRangeHEAD = this.getHEADVersion(versionRanges);
      this.props.actions.updateVulnerableRangeByComponent(versionRangeHEAD);
    } else if (!_.isEmpty(versionRanges)) {
      this.props.actions.updateVulnerableRangeByComponent(versionRanges[0]);
    }
  }
  UNSAFE_componentWillUpdate(nextProps) {
    let store = nextProps.artifactState,
      artifact = this.props.artifact,
      currentComponentId = store.componentId,
      currentVersionRange = store.vulnerableRangeByComponent[currentComponentId] || {},
      artifactComponents = artifact.artifactComponents,
      currentArtifactComponent =
        _.find(artifactComponents, artifactComponent => {
          return artifactComponent.componentId === currentComponentId;
        }) || {},
      versionRanges = currentArtifactComponent.versionRanges || [];
    if (_.isEmpty(currentVersionRange) && !_.isEmpty(versionRanges)) {
      this.props.actions.updateVulnerableRangeByComponent(versionRanges[0]);
    }
  }
  getHEADVersion(versionRanges) {
    return versionRanges.find(range => range.versionRange === 'HEAD');
  }
  render() {
    let store = this.props.artifactState,
      artifact = this.props.artifact,
      rangeType = this.props.rangeType || vulnerabilityRangeTypesMap.VERSIONS,
      currentComponentId = store.componentId,
      currentVersionRange = store.vulnerableRangeByComponent[currentComponentId] || {},
      patchElement,
      patch = currentVersionRange.patch,
      patchSha = patch ? patch.slice(-6) : null,
      artifactComponents = artifact.artifactComponents,
      currentArtifactComponent =
        _.find(artifactComponents, artifactComponent => {
          return artifactComponent.componentId === currentComponentId;
        }) || {},
      repoUrl = currentArtifactComponent.coordOne,
      versionRanges =
        (currentArtifactComponent &&
          currentArtifactComponent.versionRanges &&
          currentArtifactComponent.versionRanges.filter(range => range.versionRange !== 'HEAD')) ||
        [],
      commitHashRanges =
        (currentArtifactComponent &&
          currentArtifactComponent.versionRanges &&
          currentArtifactComponent.versionRanges.filter(range => range.versionRange === 'HEAD')) ||
        [],
      fix =
        currentVersionRange &&
        currentVersionRange.updateToVersion &&
        Helpers.isCommitHash(currentVersionRange.updateToVersion)
          ? currentVersionRange.updateToVersion.slice(-6)
          : currentVersionRange.updateToVersion,
      fixText = Helpers.isCommitHash(currentVersionRange.updateToVersion) ? (
        <Link
          to={`https://${repoUrl}/commit/${currentVersionRange.updateToVersion}`}
          target="_blank"
          className="link--primary"
        >
          {fix}
        </Link>
      ) : (
        fix
      );
    if (patchSha) {
      patchElement = (
        <Link to={patch} target="_blank" className="link--primary">
          {patchSha}
        </Link>
      );
    } else {
      patchElement = <div>n/a</div>;
    }
    const listData =
      rangeType === vulnerabilityRangeTypesMap.VERSIONS ? versionRanges : commitHashRanges;
    return (
      <div className="grid">
        <div className="grid__item col-5-8">
          <ArtifactViewSelect
            componentId={currentArtifactComponent.componentId}
            listData={listData}
            rangeType={rangeType}
          />
        </div>
        <div className="grid__item col-3-8 phone--pv">
          <div className="grid">
            <div className="grid__item text--center">
              <div>Patch</div>
              <div className="mt-- bo--1 pv-- ph- border-color--white-dark bg-color--white-medium">
                {patchElement}
              </div>
            </div>
            <div className="grid__item text--center">
              <div>Fix</div>
              <div className="mt-- bo--1 pv-- ph- border-color--white-dark bg-color--white-medium">
                {fixText || 'n/a'}
              </div>
            </div>
            <div className="grid__item text--center">
              <div>Latest</div>
              <div className="mt-- bo--1 pv-- ph- border-color--white-dark bg-color--white-medium">
                {currentArtifactComponent.componentLatestRelease || 'n/a'}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    routing: state.routing,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentFixInfoRangeOverview);
